export const TEMPLATES_VIEW_MODE = 'templates_view_mode';
export const CAMPAIGNS_VIEW_MODE = 'campaigns_view_mode';
